import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

export const useReduxQuery = ({
  queryFn,
  args,
  selector,
  onLoading,
  onResponse,
  onError,
  enabled = true,
}) => {
  const dispatch = useDispatch();
  const isLoading = useSelector(selector);

  return useCallback(() => {
    if (!enabled) return;
    if (isLoading) return;

    const hasAllArgs = args.every(Boolean);
    if (!hasAllArgs) return;

    const doQuery = async () => {
      try {
        dispatch(onLoading(true));

        const response = await queryFn(...args);
        onResponse(response);
      } catch (error) {
        dispatch(onError(error));
      } finally {
        dispatch(onLoading(false));
      }
    };

    doQuery();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...args]);
};
